import { ChangeDetectionStrategy, Component, ElementRef, ViewChild, afterNextRender, input } from '@angular/core';
import { FormFieldComponent } from '../form-field.component.js';

@Component({
    selector: 'ui-number-form-field',
    templateUrl: './number-form-field.component.html',
    styleUrls: ['../form-fields.shared.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class NumberFormFieldComponent extends FormFieldComponent<number> {
	public readonly maxValue = input<number>();
	public readonly minValue = input<number>();
	public readonly focusOnField = input<boolean>(false);

	@ViewChild('input') inputElement?: ElementRef;

	constructor() {
		super();

		afterNextRender(() => {
			if (this.focusOnField() && this.canFocusField() && this.inputElement) {
				this.inputElement.nativeElement.focus();
			}
		});
	}

	handleModelChange(value?: number): void {
		let valueForInvalidValue: number | undefined = undefined;
		const minAndMaxResult = this.validateMinAndMax(value);

		if (minAndMaxResult.isInvalidMax) {
			valueForInvalidValue = this.maxValue();
		} else if (minAndMaxResult.isInvalidMin) {
			valueForInvalidValue = this.minValue();
		}

		super.updateValue(value, {
			valueForInvalidValue: valueForInvalidValue
		});
	}

	protected getHint(value?: number): string | undefined {
		const minAndMaxResult = this.validateMinAndMax(value);

		if (minAndMaxResult.isInvalidMax) {
			return `Max value is ${this.maxValue()}`;
		}
		if (minAndMaxResult.isInvalidMin) {
			return `Min value is ${this.minValue()}`;
		}

		return undefined;
	}

	protected isValueValid(value?: number): boolean {
		const minAndMaxResult = this.validateMinAndMax(value);

		if (minAndMaxResult.isInvalidMax || minAndMaxResult.isInvalidMin) {
			return false;
		}

		return true;
	}

	private validateMinAndMax(value?: number): {
		isInvalidMax: boolean;
		isInvalidMin: boolean;
	} {
		let isInvalidMax: boolean = false;
		let isInvalidMin: boolean = false;

		const maxValue = this.maxValue();
		const minValue = this.minValue();

		if (value || value === 0) {
			if ((maxValue || maxValue === 0) && value > maxValue) {
				isInvalidMax = true;
			}
			if ((minValue || minValue === 0) && value < minValue) {
				isInvalidMin = true;
			}
		}

		return {
			isInvalidMax: isInvalidMax,
			isInvalidMin: isInvalidMin
		};
	}
}
